import { createTokenHeader } from '../utils/functions/headers';
import { MyCatalogue } from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const InventoryService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['inventoryList'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getInventoryList: build.query({
        query: (params) => ({
          url: 'product/inventories/list',
          method: 'GET',
          params: params,
        }),
        transformResponse: (
          data: MyCatalogue[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['inventoryList'],
      }),
      getInventoryDetailsById: build.query<
        MyCatalogue,
        string
      >({
        query: (inventoryId) => ({
          url: `product-inventories/${inventoryId}`,
          method: 'GET',
        }),
      }),
      inventoryImport: build.mutation({
        query: ({ data, enterprise }) => ({
          url: `products/inventory/import/${enterprise}`,
          method: 'POST',
          data: data,
          headers: createTokenHeader(),
        }),
      }),
      inventoryExport: build.mutation({
        query: (data) => ({
          url: 'products/inventory/export',
          method: 'POST',
          data,
        }),
      }),
      getInventoryCount: build.query({
        query: (params) => ({
          url: 'product-inventories/count',
          method: 'GET',
          params,
        }),
      }),
      matnrInventorySync: build.mutation({
        query: (data) => ({
          url: 'products/sap-sync',
          method: 'PUT',
          data: data.payload,
          params: data.params,
        }),
      }),
      editClosingQty: build.mutation({
        query: (data) => ({
          url: 'products/inventory/closing-quantity-edit',
          method: 'POST',
          data,
        }),
        invalidatesTags: ['inventoryList'],
      }),
    }),
  });

export const {
  useGetInventoryListQuery,
  useGetInventoryDetailsByIdQuery,
  useInventoryImportMutation,
  useGetInventoryCountQuery,
  useMatnrInventorySyncMutation,
  useInventoryExportMutation,
  useEditClosingQtyMutation,
} = InventoryService;
